module.exports = __webpack_public_path__ + "static/media/Asset 10.2e025438.svg";